(function (angular) {
    'use strict';

    angular.module('branch')
        /**
         *
         */
        .controller('RulesCtrl',
        ['$scope', 'rulesService', '$stateParams', '$state', '$uibModal', 'growlService', 'rulesData', 'permissionService', 'channelsData','sweetAlertService',
            function ($scope, rulesService, $stateParams, $state, $uibModal, growlService, rulesData, permissionService, channelsData, sweetAlertService) {

                    $scope.deletePermission = permissionService.checkPermission("rule:sets:d");
                    $scope.writePermission = permissionService.checkPermission("rule:sets:w");
                    $scope.rulesData = rulesData || [];

                    $scope.channelIcons = {
                        sms: "ci-sms c-sms-channel-icon",
                        mms: "ci-mms c-mms-channel-icon",
                        nativePush: 'ci-app-messaging c-app-channel-icon',
                        appMessaging: "ci-web c-web-channel-icon",
                        email: "ci-email c-email-channel-icon",
                        twitterDm: "ci-twitter-dm c-twitter-dm-channel-icon",
                        fbMessenger: "ci-messenger c-fb-channel-icon"
                    };

                    $scope.editRule = function (rule) {
                        var modalInstance = $uibModal.open({
                            templateUrl: 'components/toolkit/branch/templates/ruleCreationModal.html',
                            size: 'md',
                            resolve: {
                                channelsData: function () { return channelsData; },
                                ruleData: function () { return rule; }
                            },
                            controller: 'ruleCreationModalCtrl'
                        });
                        modalInstance.result.then(function (result) {
                            var ind = _.findIndex($scope.rulesData, { id: result.id });
                            $scope.rulesData.splice(ind, 1, result);
                        });
                    };

                    $scope.deleteRule = function (rule) {
                        sweetAlertService.confirmationAlert(
                            "Are you sure?",
                            "Are you sure you want to remove the rule " + rule.name + "?",
                            "Remove",
                            "Cancel",
                            function (isConfirmed) {
                                if (isConfirmed) {
                                    rulesService.deleteRule($stateParams.pickedApiSpaceId, rule.id).then(function (ret) {
                                        growlService.success('Rule deleted');
                                        var index = $scope.rulesData.indexOf(rule);
                                        $scope.rulesData.splice(index, 1);

                                    }).catch(function (error) {
                                        growlService.danger("Rule wasn't deleted due to: " + error.statusText);
                                    });
                                }
                            }
                        );

                       
                    };

                    $scope.create = function create() {
                        var modalInstance = $uibModal.open({
                            templateUrl: 'components/toolkit/branch/templates/ruleCreationModal.html',
                            size: 'md',
                            resolve: {
                                channelsData: function () { return channelsData; },
                                ruleData: function () { return false; }
                            },
                            controller: 'ruleCreationModalCtrl'
                        });
                        modalInstance.result.then(function (result) {
                            $scope.rulesData.push(result);
                        });
                    };


                }]);


})(window.angular);
